// extracted by mini-css-extract-plugin
module.exports = {"box":"_1pC6gZzvvar3HKUIJ-B2Ks","min-height":"_1RiLFi-ph8v8mOMdcBQfRF","preLoaderShimmer":"_1cnhuqO9JlBGt6LDEvtiSH"};